/**
 * Вход в админку — разметка 1:1 из legacy htdocs/core/templates/admin_login.tpl
 * (шаблон рендерился внутри admin.tpl, поэтому тот же набор CSS).
 *
 * Соответствие legacy:
 *   .form-signin / .form-signin-heading — форма входа (docs.min.css)
 *   .bs-callout.bs-callout-danger       — блок «Ошибка / Неверная связка логин-пароль»
 */

import { useState, type FormEvent } from 'react'
import { Navigate, useNavigate } from 'react-router-dom'

import { api } from '@/api/client'
import { saveTokens, type TokenPair } from '@/api/tokens'
import { clearCache } from '@/lib/apiCache'
import { ADMIN_CSS, useStylesheets } from '@/lib/useStylesheets'
import { useSession } from '@/session/SessionProvider'

export function AdminLoginPage() {
  useStylesheets(ADMIN_CSS)

  const { admin, refresh } = useSession()
  const navigate = useNavigate()
  const [error, setError] = useState(false)

  if (admin !== null) return <Navigate to="/admin" replace />

  async function submit(event: FormEvent<HTMLFormElement>): Promise<void> {
    event.preventDefault()
    const form = new FormData(event.currentTarget)
    try {
      clearCache()   // кеш прошлой админ-сессии — не наш
      // Пара токенов: доступ на сутки + одноразовый refresh на полгода.
      const pair = await api.post<TokenPair>('/api/admin/auth/token', {
        login: form.get('login'),
        password: form.get('password'),
      })
      saveTokens('admin', pair)
      await refresh()
      navigate('/admin')
    } catch {
      // legacy: $data.error = 1 → та же форма с bs-callout
      setError(true)
    }
  }

  return (
    <div className="container">
      <form className="form-signin" method="POST" onSubmit={(event) => void submit(event)}>
        <h2 className="form-signin-heading">Панель управления</h2>
        {error && (
          <div className="bs-callout bs-callout-danger" id="callout-btn-group-anchor-btn">
            <h4>Ошибка</h4>
            <p>Неверная связка логин-пароль</p>
          </div>
        )}
        <label htmlFor="admin_login" className="sr-only">
          Логин
        </label>
        <input
          name="login"
          type="login"
          id="admin_login"
          className="form-control"
          placeholder="Логин"
          required
          autoFocus
        />
        <label htmlFor="inputPassword" className="sr-only">
          Пароль
        </label>
        <input
          name="password"
          type="password"
          id="admin_password"
          className="form-control"
          placeholder="Пароль"
          required
        />
        <button className="btn btn-lg btn-success btn-block" type="submit">
          Войти
        </button>
      </form>
    </div>
  )
}
